export default "__VITE_ASSET__8f23096d__"